import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import AppointmentService from "../../../Services/AppointmentService";
import {
  Checkbox,
  DatePicker,
  Flex,
  message,
  Modal,
  Spin,
  TimePicker,
} from "antd";
import { Switch, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import dayjs from "dayjs";
import moment from "moment";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import enrollmentServices from "../../../Services/enrollmentServices";
import {
  convertDate,
  ConvertTime,
  convertUTCDate,
} from "../../../utils/convertionFunc";
import PatientService from "../../../Services/PatientService";
import { useDispatch } from "react-redux";
import CommonFunctions from "../../Shared/CommonFunctions";

const RequestAppointments = () => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmedDate, setConfirmedDate] = useState("");
  const [confirmedTime, setConfirmedTime] = useState("");
  const [selectedAppt, setSelectedAppt] = useState(null);
  const [confirmLoader, setConfirmLoader] = useState(false);
  const [paymentOptionMod, setPaymentOptionMod] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [patientMembershipDet, setPatientMembershipDet] = useState(null);
  const [membershipAvailed, setMembershipAvalied] = useState(false);
  const [discountApplied, setDiscountApplied] = useState(false);
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const date = new Date();
  const loginObj = sessionStorage.getItem("login_result");
  const loggedUser = loginObj ? JSON.parse(loginObj) : null;
  const firstDateObj = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDateObj = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const firstDate = `${firstDateObj.getMonth() + 1}/${firstDateObj.getDate()}/${firstDateObj.getFullYear()}`;
  const lastDate = `${lastDateObj.getMonth() + 1}/${lastDateObj.getDate()}/${lastDateObj.getFullYear()}`;

  useEffect(() => {
    fetchAppointmentsList();
  }, []);
  const fetchAppointmentsList = async () => {
    try {
      let payload = {
        pageNo: 1,
        account_Id: loggedUser.user.account_Id,
        clinic_Id: loggedUser.user.clinic_Id,
        userId: loggedUser.user.userId,
        fromDate: firstDate,
        toDate: lastDate,
      };
      let result = await AppointmentService.apptRequestList(payload);
      setData(result.data.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchMembershipDetails = async (patientDet) => {
    if (!patientDet?.membershipCard) return;
    const payload = {
      membershipCard: patientDet?.membershipCard,
      serviceCategory: "APPT",
    };

    try {
      const response = await PatientService.patientMembershipDet(payload);
      const apptMembership = response?.data?.data.find(
        (item) => item.serviceCategory === "APPT",
      );
      setPatientMembershipDet(apptMembership);
    } catch (e) {
      console.error(e);
    }
  };

  const handleConfirmModal = (item) => {
    setConfirmModal(true);
    setSelectedAppt(item);
  };

  const handleCloseConfirmModal = () => {
    setConfirmModal(false);
  };

  const handlePayOptionModal = async (item) => {
    debugger;
    const [resp2, resp3] = await Promise.all([
      fetchCurrApptPatient(item),
      fetchDoctorSlots(item),
    ]);
    await fetchMembershipDetails(resp2);

    let selectedTime = dayjs(`${item.startTime}`, "hh:mm A");

    const selectedSlotObject = resp3?.find((slot) => {
      const consultationDate = dayjs(item.consultationDate);
      const slotFromDate = dayjs(slot.fromDate, "MM/DD/YYYY").startOf("day");
      const slotToDate = dayjs(slot.toDate, "MM/DD/YYYY").endOf("day");

      if (
        consultationDate.isBefore(slotFromDate) ||
        consultationDate.isAfter(slotToDate)
      ) {
        return false;
      }

      let slotStart = dayjs(slot.fromTime, "HH:mm");
      let slotEnd = dayjs(slot.toTime, "HH:mm");

      if (slotEnd.isSameOrBefore(slotStart)) {
        slotEnd = slotEnd.add(1, "day");

        if (selectedTime.isBefore(slotStart)) {
          selectedTime = selectedTime.add(1, "day");
        }
      }

      return selectedTime.isBetween(slotStart, slotEnd, null, "[]");
    });

    setSelectedSlot({
      slotData: selectedSlotObject || null,
      time: item.confirmStartTime,
      selectedDate: dayjs(item.confirmConsultationDate).format("MM/DD/YYYY"),
    });
    setPaymentOptionMod(true);
    setSelectedAppt(item);
  };

  const handleClosePayTypeModal = () => {
    setPaymentOptionMod(false);
    membershipAvailed && setMembershipAvalied(false);
    setSelectedAppt(null);
  };

  const handleFromDate = (date, dateString) => {
    setConfirmedDate(dateString);
    if (date && date.isSame(moment(), "day")) {
      // Reset time to current time if today is selected
      setConfirmedTime(moment());
    } else {
      setConfirmedTime(null); // Reset time if not today
    }
  };

  const disabledTime = () => {
    if (confirmedDate && dayjs(confirmedDate).isSame(moment(), "day")) {
      const currentHour = moment().hour();
      const currentMinute = moment().minute();
      return {
        disabledHours: () =>
          [...Array(24).keys()].filter((h) => h < currentHour),
        disabledMinutes: (selectedHour) =>
          selectedHour === currentHour
            ? [...Array(60).keys()].filter((m) => m < currentMinute)
            : [],
      };
    }
    return {}; // No restrictions for other days
  };

  const isValidTime = (timeStr) => {
    return dayjs(timeStr, "HH:mm", true).isValid();
  };

  const handleStartTime = (time, timeString) => {
    setConfirmedTime(time);
  };

  const handleSubmitConfirmation = async () => {
    const now = convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss");

    if (!confirmedDate) {
      message.error("Please confirmation date!!");
      return;
    }

    if (!confirmedTime) {
      message.error("Please confirmation time!!");
      return;
    }
    const start = dayjs(confirmedTime, "hh:mm A");
    setConfirmLoader(true);
    const confConsDate = dayjs(confirmedDate, "MM-DD-YYYY")
      .hour(dayjs(confirmedTime).hour())
      .minute(dayjs(confirmedTime).minute())
      .second(0)
      .format("YYYY-MM-DD HH:mm:ss");

    const payload = {
      ...selectedAppt,
      modifiedDate: now,
      modifiedBy: loggedUser.user.userId,
      confirmConsultationDate: confConsDate,
      confirmEndTime: start.add(15, "minutes").format("hh:mm A"),
      confirmStartTime: start.format("hh:mm A"),
      requestAppointmentStatus: "CONFIRMED",
    };

    try {
      await AppointmentService.requestApptConfirmation(payload);
      message.success("Appointment date & time confirmed!!");
      const requestListpayload = {
        pageNo: 1,
      };
      if (loggedUser?.user?.rolecode === "ACCT_ADM") {
        requestListpayload.account_Id = loggedUser.user.account_Id;
      } else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
        requestListpayload.account_Id = loggedUser.user.account_Id;
        requestListpayload.clinic_Id = loggedUser.user.clinic_Id;
      }

      const payloadKeys = Object.keys(requestListpayload);
      if (
        !payloadKeys.includes("fromDate") &&
        !payloadKeys.includes("toDate")
      ) {
        requestListpayload.fromDate = firstDate;
        requestListpayload.toDate = lastDate;
      }
      setConfirmModal(false);
    } catch (e) {
      console.error(e);
    } finally {
      setConfirmLoader(false);
    }
  };

  const fetchCurrApptPatient = async (apptObj) => {
    try {
      const patientPayload = { patientId: apptObj.patientId, status: 1 };
      const res = await PatientService.PatientList(patientPayload);
      const selectedPatData = res.data[0];
      setSelectedPatient(selectedPatData);
      return selectedPatData;
    } catch (e) {
      console.error(e);
    }
  };

  const fetchDoctorSlots = async (apptObj) => {
    const payload = {
      userId: apptObj.userId,
      status: 1,
    };

    try {
      const response = await AppointmentService.UserSavedTemplates(payload);
      return response.data;
    } catch (e) {
      console.error(e);
    }
  };

  const handleMembershipSelection = (value) => {
    setMembershipAvalied(value);
  };

  const calculateDiscountAmount = (itemAmt, membershipObj) => {
    const currentPrice = itemAmt || 0;
    const discountAmount = Math.floor(
      currentPrice * (membershipObj?.discountPercentage / 100),
    );
    return discountAmount;
  };

  const getDiscount = (appointmentType) => {
    return appointmentType === "APPT_VIDEO" || appointmentType === "APPT_AUDIO"
      ? selectedSlot?.slotData?.videoConsultDiscountAmount || 0
      : appointmentType === "APPT_INPERSON"
        ? selectedSlot?.slotData?.inPersonDiscountAmount || 0
        : 0;
  };

  const getConsultFee = (appointmentType) => {
    return appointmentType === "APPT_VIDEO" || appointmentType === "APPT_AUDIO"
      ? discountApplied && selectedSlot?.slotData?.videoConsultPayableAmount
        ? selectedSlot?.slotData?.videoConsultPayableAmount
        : selectedSlot?.slotData?.videoFee
      : appointmentType === "APPT_INPERSON"
        ? discountApplied && selectedSlot?.slotData?.inPersonPayableAmount
          ? selectedSlot?.slotData?.inPersonPayableAmount
          : selectedSlot?.slotData?.inpersonFee
        : 0;
  };

  const calculateDiscountedPrice = () => {
    if (patientMembershipDet && membershipAvailed) {
      const currentPrice = getConsultFee(selectedAppt.consultationType) || 0;
      const discountAmount = Math.floor(
        currentPrice * ((patientMembershipDet?.discountPercentage || 0) / 100),
      );
      const finalMedPrice = currentPrice - discountAmount;
      return finalMedPrice?.toFixed(2);
    } else if (discountApplied) {
      const currentPrice = getConsultFee(selectedAppt.consultationType) || 0;
      const discountAmount = getDiscount(selectedAppt.consultationType);
      const finalMedPrice = currentPrice - discountAmount;
      return finalMedPrice?.toFixed(2);
    } else {
      return getConsultFee(selectedAppt.consultationType);
    }
  };

  const handleDiscountApply = (e) => {
    const isChecked = e.target.checked;
    setDiscountApplied(isChecked);
  };

  const handleProceedPayment = async (payType) => {
    setLoader(true);
    if (!selectedSlot) {
      message.error(
        "Slot is not selected. Select again and book appointment!!",
      );
      return;
    }
    const now = convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss");
    const start = dayjs(selectedSlot.time, "hh:mm A");

    const consultFee =
      selectedAppt.consultationType === "APPT_VIDEO" ||
      selectedAppt.consultationType === "APPT_AUDIO"
        ? selectedSlot.slotData.videoFee
        : selectedAppt.consultationType === "APPT_INPERSON"
          ? selectedSlot.slotData.inpersonFee
          : "";
    const totalAmt =
      selectedAppt.consultationType === "APPT_VIDEO" ||
      selectedAppt.consultationType === "APPT_AUDIO"
        ? discountApplied
          ? selectedSlot?.slotData?.videoConsultPayableAmount
          : selectedSlot.slotData.videoFee
        : selectedAppt.consultationType === "APPT_INPERSON"
          ? discountApplied
            ? selectedSlot?.slotData?.inPersonPayableAmount
            : selectedSlot.slotData.inpersonFee
          : "";
    let discountAmt = 0;
    let discountPer = 0;
    if (discountApplied) {
      discountAmt =
        selectedAppt.consultationType === "APPT_VIDEO" ||
        selectedAppt.consultationType === "APPT_AUDIO"
          ? selectedSlot.slotData.videoConsultDiscountAmount
          : selectedAppt.consultationType === "APPT_INPERSON"
            ? selectedSlot.slotData.inPersonDiscountAmount
            : 0;
      discountPer =
        selectedAppt.consultationType === "APPT_VIDEO" ||
        selectedAppt.consultationType === "APPT_AUDIO"
          ? selectedSlot.slotData.videoConsultDiscountPercentage
          : selectedAppt.consultationType === "APPT_INPERSON"
            ? selectedSlot.slotData.inPersonDiscountPercentage
            : 0;
    }

    let data = {
      consultationReason: "",
      complaintCode: "",
      createdBy: loggedUser.user.userId,
      createdDate: now,
      email: selectedPatient.email,
      account_Id: selectedSlot.slotData.account_Id,
      clinic_Id: selectedSlot.slotData.clinic_Id,
      firstName: selectedPatient.firstName,
      lastName: selectedPatient.lastName,
      specialityCode: loggedUser.user.specialityCode,
      mobile: selectedPatient.mobile,
      modifiedBy: loggedUser.user.userId,
      modifiedDate: now,
      patientId: selectedPatient.patientId,
      paymentConsultation: "BC",
      paymentType: payType,
      appointmentDate: convertDate(
        dayjs(selectedAppt.confirmConsultationDate).format("MM/DD/YYYY"),
      ),
      startTime: start.format("hh:mm A"),
      endTime: start.add(15, "minutes").format("hh:mm A"),
      serviceName:
        selectedAppt.consultationType === "APPT_VIDEO"
          ? "Video Consultation"
          : selectedAppt.consultationType === "APPT_AUDIO"
            ? "Audio Consultation"
            : selectedAppt.consultationType === "APPT_INPERSON"
              ? "Inperson Consultation"
              : "",
      serviceCode: selectedAppt.consultationType,
      consultationFee: consultFee,
      totalAmount: totalAmt,
      userId: loggedUser.user.userId,
      patientType: "E",
      patientRegFeeYN: "N",
      status: 0,
      paymentReceived: "N",
      membershipCard: "",
      membershipCode: "",
      membershipDiscount: 0,
      membershipName: "",
      isMembershipDiscount: "N",
      discountAmount: discountAmt,
      discountPercentage: discountPer,
      requestAppointmentId: selectedAppt.requestAppointmentId,
    };

    if (data.startTime > data.endTime) {
      message.error("Select Valid Start time and End time");
      setLoader(false);
      return;
    }

    const currentTime = ConvertTime(dayjs());
    const startTime = ConvertTime(dayjs(selectedSlot.time));

    if (
      startTime < currentTime &&
      dayjs().format("MM/DD/YYYY") ===
        convertDate(
          dayjs(selectedAppt.confirmConsultationDate).format("MM/DD/YYYY"),
        )
    ) {
      message.error("Scheduled time has already ended");
      setLoader(false);
      return;
    }

    if (patientMembershipDet && membershipAvailed) {
      const membershipDis = calculateDiscountAmount(
        data.totalAmount,
        patientMembershipDet,
      );
      const amountAfterDis = data.totalAmount - membershipDis;

      data.membershipCard = patientMembershipDet?.membershipCard;
      data.membershipCode = patientMembershipDet?.membershipCode;
      data.membershipDiscount = membershipDis;
      data.totalAmount = amountAfterDis;
      data.discountAmount = membershipDis;
      data.discountPercentage = patientMembershipDet?.discountPercentage;
      data.membershipName = patientMembershipDet?.membershipCode;
      data.isMembershipDiscount = "Y";
    }

    if (payType === "Cash") {
      try {
        data.paymentReceived = "Y";
        data.status = 1;
        await enrollmentServices.Invite(data);
        message.success("Appointment booked successfully using Virtual Cash");
        setLoader(false);
        history.push(APP_ROUTES.DASHBOARD);
        return;
      } catch (e) {
        console.error(e);
        message.error("Something went wrong, please try again");
        setLoader(false);
      }
    } else if (payType === "Digital") {
      data.status = -1;

      CommonFunctions.ExisTingPatientPayment(data)
        .then(() => {
          setLoader(false);
          if (loggedUser?.user?.currencyCode != "INR") {
            message.success(
              "Appointment booked successfully",
            );

            history.push(APP_ROUTES.DASHBOARD);
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error);
          setLoader(false);
          message.error("An Error occurred, try again");
        });
    } else if (payType === "link") {
      data.paymentType = "Share_Link";
      try {
        const result = await enrollmentServices.Invite(data);
        if (result.data.code === "FAILED") {
          message.error("Sending Invitation Failed, Retry");
          setLoader(false);
          return;
        }
        if (result.data.code === "SUCCESS") {
          message.success("Payment Link and invitation sent Successfully");
          setLoader(false);
          history.push(APP_ROUTES.DASHBOARD);
          return;
        }
      } catch (e) {
        message.error("Something went wrong. Please try after sometime!!");
        setLoader(false);
      }
    }
  };
  return (
    <Layouts>
      <div>
        <div className="flex items-center justify-between">
          {" "}
          <h2 className="my-4">Requested Appointments</h2>
          <h2
            className="cursor-pointer"
            onClick={() => {
              history.push(APP_ROUTES.APPOINTMENTS);
            }}
          >
            {"<- Back"}
          </h2>
        </div>
        <div className={` w-full mx-auto rounded-lg flex justify-center py-2`}>
          <table className={`w-full m-0 relative`}>
            <thead className="sticky top-0 z-30">
              <tr>
                <th>App. Date</th>
                <th>Patient Id</th>
                <th>Patient Name</th>
                <th>Doctor Id</th>
                <th>Doctor Name</th>
                <th>Consultation Type</th>
                <th>Consultation Date</th>
                <th>Confirmed Date</th>
                <th>Status</th>
                <th colSpan={3}>Action</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {data?.map((item, idx) => (
                <>
                  <tr key={idx}>
                    <td>{dayjs(item.consultationDate).format("DD/MM/YYYY")}</td>
                    <td>{item.patientId}</td>
                    <td>{item.patientName}</td>
                    <td>{item.userId}</td>
                    <td>{item.userName}</td>
                    <td>
                      {item.consultationType === "APPT_VIDEO"
                        ? "Video Consultation"
                        : item.consultationType === "APPT_AUDIO"
                          ? "Audio Consultation"
                          : item.consultationType === "APPT_INPERSON"
                            ? "In-Person Consultation"
                            : item.consultationType === "APPT_HOMEVISIT"
                              ? "Home-Visit Consultation"
                              : ""}
                    </td>
                    <td>
                      {dayjs(item.consultationDate).format(
                        "DD/MM/YYYY hh:mm A",
                      )}
                    </td>
                    <td>
                      {item.confirmConsultationDate
                        ? dayjs(item.confirmConsultationDate).format(
                            "DD/MM/YYYY hh:mm A",
                          )
                        : "-"}
                    </td>
                    <td>{item.requestAppointmentStatus || "-"}</td>
                    <td colSpan={3}>
                      <div className="flex items-center justify-center gap-2">
                        <button
                          disabled={item.requestAppointmentStatus === "PAID"}
                          onClick={() => handleConfirmModal(item)}
                          className="p-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Confirm
                        </button>
                        <button
                          onClick={() => handlePayOptionModal(item)}
                          disabled={
                            item.requestAppointmentStatus !== "CONFIRMED" ||
                            item.requestAppointmentStatus === "PAID"
                          }
                          className="p-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Pay
                        </button>
                      </div>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
        <Modal
          title="Confirm Date"
          open={confirmModal}
          onCancel={handleCloseConfirmModal}
          footer={[]}
          destroyOnClose
        >
          <div>
            <div className="my-3">
              <div className="w-full flex items-center gap-2">
                <div className="w-2/5 flex flex-col">
                  <label className="text-base font-semibold mb-1.5">Date</label>
                  <DatePicker
                    placeholder="From Date"
                    format="MM/DD/YYYY"
                    className="h-10 rounded-lg outline-none"
                    onChange={handleFromDate}
                    disabledDate={(current) =>
                      current && current.isBefore(moment().startOf("day"))
                    }
                  />
                </div>
                <div className="w-2/5 flex flex-col">
                  <label className="text-base font-semibold mb-1.5">Time</label>
                  <TimePicker
                    format="h:mm A"
                    className="h-10 rounded-lg outline-none"
                    onChange={(value) => handleStartTime(value)}
                    onSelect={(value) => handleStartTime(value)}
                    value={
                      isValidTime(confirmedTime)
                        ? dayjs(confirmedTime, "HH:mm")
                        : null
                    }
                    minuteStep={10}
                    needConfirm={false}
                    showNow={false}
                    disabledTime={disabledTime}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <button
                disabled={confirmLoader}
                onClick={handleCloseConfirmModal}
                className="py-2 w-36 text-sm font-semibold border border-brand-primaryColor rounded-md px-3 text-white disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Cancel
              </button>
              <button
                disabled={confirmLoader}
                onClick={handleSubmitConfirmation}
                className="py-2 w-36 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal>

        {/* Pay type selection */}
        <Modal
          title="Payment Options"
          open={paymentOptionMod}
          onCancel={handleClosePayTypeModal}
          footer={[]}
          width={patientMembershipDet ? "50%" : "30%"}
          destroyOnClose
        >
          <>
            {!loggedUser.user ? (
              <div className="h-52 flex items-center justify-center mt-[10%]">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : (
              <div
                className={`w-full ${patientMembershipDet ? "flex justify-between" : ""}`}
              >
                <div>
                  <div className="w-full flex justify-between items-center my-1">
                    <span>Consultation Fee :</span>
                    <span>
                      {loggedUser?.user?.currencyCode || ""}{" "}
                      {selectedAppt?.consultationType === "APPT_VIDEO"
                        ? selectedSlot?.slotData?.videoFee
                        : selectedAppt?.consultationType === "APPT_INPERSON"
                          ? selectedSlot?.slotData?.inpersonFee
                          : ""}
                    </span>
                  </div>
                  <div className="w-full flex justify-between items-center my-1">
                    <div className="flex items-center gap-1.5">
                      <Checkbox
                        disabled={
                          membershipAvailed ||
                          getDiscount(selectedAppt?.consultationType) === 0
                        }
                        checked={discountApplied}
                        onChange={handleDiscountApply}
                        className="disabled:opacity-50 disabled:cursor-not-allowed"
                      />
                      <span>Discount :</span>
                    </div>
                    <span>{`${loggedUser?.user?.currencyCode || ""} ${getDiscount(selectedAppt?.consultationType)}`}</span>
                  </div>
                  <div className="w-full flex justify-between items-center my-1 mb-2">
                    <span>Total :</span>
                    <div>
                      <span
                        className={`${membershipAvailed || discountApplied ? "line-through mr-1" : ""}`}
                      >
                        {`${loggedUser?.user?.currencyCode || ""} ${getConsultFee(selectedAppt?.consultationType)}`}
                      </span>
                      <span
                        className={`${membershipAvailed || discountApplied ? "ml-1" : ""}`}
                      >
                        {(membershipAvailed || discountApplied) &&
                          calculateDiscountedPrice()}
                      </span>
                    </div>
                  </div>
                  <p>Payment Options :</p>
                  <div className="m-6">
                    <button
                      disabled={loader}
                      className="py-2 min-w-full w-36 mb-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                      onClick={() => handleProceedPayment("Digital")}
                    >
                      Digital
                    </button>
                    <button
                      disabled={loader}
                      onClick={() => handleProceedPayment("link")}
                      className="py-2 min-w-full w-36 mb-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Share payment link
                    </button>
                    <div>
                      <button
                        disabled={loader}
                        className="py-2 min-w-full w-36 mb-2 text-sm font-semibold text-white bg-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => handleProceedPayment("Cash")}
                      >
                        Cash
                      </button>
                    </div>
                  </div>
                </div>

                <div>
                  {patientMembershipDet && (
                    <div
                      style={{
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      }}
                      className="w-full font-inter overflow-hidden bg-brand-White rounded-2xl"
                    >
                      {/* Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          background:
                            "linear-gradient(to right, #e3f0f9, #d6e6ef)",
                          padding: "12px 16px",
                          borderBottom: "1px solid #e5e7eb",
                          //   backgroundImage: `url(${MembershipBg})`,
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <div>
                            {/* <CheckOutlined style={{ color: "#1976d2" }} /> */}
                            <div
                              className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${
                                patientMembershipDet?.membershipCode ===
                                "SINGLE"
                                  ? "from-[#81CAF4] to-[#58B4E9]"
                                  : patientMembershipDet?.membershipCode ===
                                      "TWIN"
                                    ? "from-[#5DEB6D] to-[#34CF47]"
                                    : patientMembershipDet?.membershipCode ===
                                        "FAMILY"
                                      ? "from-[#35D9D4] to-[#1DBBB6]"
                                      : ""
                              }`}
                            >
                              <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                                <span className="font-medium text-sm">
                                  {patientMembershipDet?.membershipCode ===
                                  "SINGLE"
                                    ? "Single member"
                                    : patientMembershipDet?.membershipCode ===
                                        "TWIN"
                                      ? "Twin members"
                                      : patientMembershipDet?.membershipCode ===
                                          "FAMILY"
                                        ? "Family"
                                        : ""}
                                </span>
                                <span className="text-xs font-normal text-gray-500">
                                  Membership
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div className="text-lg font-semibold text-brand-White">
                            DOXZON
                          </div>
                          <div className="text-[8px] font-semibold text-brand-White">
                            Technology for Health
                          </div>
                        </div>
                      </div>

                      {/* Body */}
                      <div style={{ padding: "16px" }}>
                        <div
                          style={{
                            color: "#16a34a",
                            fontWeight: 600,
                            fontSize: 18,
                            // marginBottom: 6,
                          }}
                        >
                          {`Save ${loggedUser?.user?.currencyCode || ""}`}
                          {calculateDiscountAmount(
                            selectedAppt?.consultationType === "APPT_VIDEO"
                              ? selectedSlot?.slotData?.videoFee
                              : selectedSlot?.slotData?.inpersonFee,
                            patientMembershipDet,
                          ) || "-"}
                        </div>

                        <div
                          style={{
                            color: "#374151",
                            lineHeight: 1.4,
                            fontSize: 14,
                            marginBottom: 8,
                          }}
                        >
                          Get {patientMembershipDet?.discountPercentage}% off on
                          consultation.
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ fontWeight: 500, color: "#374151" }}>
                            Use membership to get discount
                          </span>
                          <Switch
                            onChange={handleMembershipSelection}
                            disabled={loader || discountApplied}
                            className="disabled:opacity-50 disabled:cursor-not-allowed"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        </Modal>
      </div>
    </Layouts>
  );
};

export default RequestAppointments;
